import React from "react";
import { useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import "./Login.css";

const Login = () => {
  const { user, loginUser, signInUsingGoogle, loading, authError, saveUser } =
    useAuth();

  const [error, setError] = useState("");
  const [loginData, setLoginData] = useState({});

  // redirect after login
  const location = useLocation();
  const history = useHistory();
  const redirect_uri = location.state?.from || "/home";

  //log in with google
  const handleGoogleLogin = () => {
    signInUsingGoogle()
      .then((result) => {
        console.log(result);
        saveUser(result.user.displayName, result.user.email, "PUT");
        history.push(redirect_uri);
        setError("");
      })
      .catch((error) => {
        const errorMessage = error.message;
        // The email of the user's account used.
        //const email = error.email;
        setError(errorMessage);
      });
  };

  const handleOnChange = (e) => {
    const field = e.target.name;
    const value = e.target.value;
    const newData = { ...loginData };
    newData[field] = value;
    console.log(newData);
    setLoginData(newData);
  };

  const handleEmailLogin = (e) => {
    loginUser(loginData.email, loginData.password, location, history);
    e.preventDefault();
  };

  return (
    <div className="signup pt-5 pb-5 mb-5">
      <form onSubmit={handleEmailLogin}>
        <div className="container d-flex flex-column justify-content-center align-items-center">
          <div className="form-floating mb-3 form-div">
            <input
              onChange={handleOnChange}
              type="email"
              className="form-control"
              name="email"
              id="floatingInput"
              placeholder="name@example.com"
              required
            />
            <label htmlFor="floatingInput">Email address</label>
          </div>
          <div className="form-floating mb-3 form-div">
            <input
              onChange={handleOnChange}
              type="password"
              className="form-control"
              name="password"
              id="floatingPassword"
              placeholder="Password"
              required
            />
            <label htmlFor="floatingPassword">Password</label>
          </div>
          <div className="error text-danger mb-3">{error}</div>
          <button className="btn btn-custom w-25 pt-2 pb-2">Login</button>
          <br />
          <Link to="/signup">Don't have an account?</Link>
          <br />
          <p className="text-muted">OR</p>
          <div className="mx-auto">
            <button
              onClick={handleGoogleLogin}
              className="btn btn-custom pe-3 pt-2 pb-2"
            >
              <i className="fab fa-google pe-3"></i>Log in with Google
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
